import React, { useState } from "react";
import { Table, Button, Badge, Modal } from "react-bootstrap";

const TicketsTable = ({ data, startIndex }) => {
  const [selectedTicket, setSelectedTicket] = useState(null);
  const tickets = data || [];

  return (
    <>
      <div className="table-responsive">
        <Table hover className="align-middle mb-0 custom-history-table">
          <thead className="bg-light">
            <tr>
              <th className="ps-4 text-secondary text-uppercase fw-bold" style={{ fontSize: "0.78rem" }}>STT</th>
              <th className="text-secondary text-uppercase fw-bold" style={{ fontSize: "0.78rem" }}>Biển số xe</th>
              <th className="text-secondary text-uppercase fw-bold" style={{ fontSize: "0.78rem" }}>Chủ xe</th>
              <th className="text-secondary text-uppercase fw-bold" style={{ fontSize: "0.78rem" }}>Thời gian vào</th>
              <th className="text-secondary text-uppercase fw-bold" style={{ fontSize: "0.78rem" }}>Thời gian ra / Trạng thái</th>
              <th className="text-end pe-4 text-secondary text-uppercase fw-bold" style={{ fontSize: "0.78rem" }}>Hành động</th>
            </tr>
          </thead>
          <tbody>
            {tickets.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center py-5 text-muted">
                  <i className="bi bi-inbox fs-2 d-block mb-2 text-secondary"></i>
                  Không tìm thấy dữ liệu xe ra vào phù hợp
                </td>
              </tr>
            ) : (
              tickets.map((ticket, index) => {
                const isIn = ticket.checkOutTime === "Đang trong bãi";
                return (
                  <tr key={index} className="table-row-hover">
                    <td className="ps-4 fw-semibold text-muted">{startIndex + index + 1}</td>
                    <td>
                      <span className="plate-badge me-2">
                        {ticket.licensePlate}
                      </span>
                    </td>
                    <td>
                      <span className="fw-medium text-dark">{ticket.owner}</span>
                    </td>
                    <td>
                      <span className="text-body">{ticket.checkInTime}</span>
                    </td>
                    <td>
                      {isIn ? (
                        <Badge bg="success" className="px-3 py-2 fw-semibold rounded-pill bg-opacity-10 text-success border border-success">
                          <i className="bi bi-geo-alt-fill me-1"></i>
                          Đang trong bãi
                        </Badge>
                      ) : (
                        <span className="text-body fw-medium">
                          {ticket.checkOutTime}
                        </span>
                      )}
                    </td>
                    <td className="text-end pe-4">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        className="rounded-pill px-3 fw-semibold"
                        onClick={() => setSelectedTicket(ticket)}
                      >
                        <i className="bi bi-eye me-1"></i>
                        Chi tiết
                      </Button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
      </div>

      <TicketDetailModal
        ticket={selectedTicket}
        onClose={() => setSelectedTicket(null)}
      />
    </>
  );
};

const TicketDetailModal = ({ ticket, onClose }) => {
  if (!ticket) return null;
  const isIn = ticket.checkOutTime === "Đang trong bãi";

  return (
    <Modal show={!!ticket} onHide={onClose} centered className="modal-edit">
      <Modal.Header closeButton className="bg-light">
        <Modal.Title className="fw-bold fs-5 text-dark d-flex align-items-center gap-2">
          <i className="bi bi-card-heading text-primary"></i>
          Chi tiết phiếu gửi xe
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <div className="text-center mb-4 p-3 bg-light rounded-3 border">
          <div className="text-muted small mb-1">BIỂN SỐ XE</div>
          <div className="fs-3 fw-extrabold text-primary font-monospace tracking-wider">
            {ticket.licensePlate}
          </div>
          <div className="mt-2">
            {isIn ? (
              <Badge bg="success" className="px-3 py-2 fw-semibold rounded-pill bg-opacity-10 text-success border border-success">
                Đang trong bãi
              </Badge>
            ) : (
              <Badge bg="secondary" className="px-3 py-2 fw-semibold rounded-pill bg-opacity-10 text-secondary border">
                Đã ra ngoài
              </Badge>
            )}
          </div>
        </div>

        <div className="list-group list-group-flush border rounded-3 overflow-hidden">
          <div className="list-group-item d-flex justify-content-between py-3">
            <span className="text-muted fw-medium">Chủ xe / Mã sinh viên:</span>
            <span className="fw-bold text-dark">{ticket.owner}</span>
          </div>
          <div className="list-group-item d-flex justify-content-between py-3">
            <span className="text-muted fw-medium">Bãi đỗ quy định:</span>
            <span className="fw-semibold text-dark">{ticket.parkingLot}</span>
          </div>
          <div className="list-group-item d-flex justify-content-between py-3">
            <span className="text-muted fw-medium">Thời gian vào bãi:</span>
            <span className="fw-semibold text-dark">{ticket.checkInTime}</span>
          </div>
          <div className="list-group-item d-flex justify-content-between py-3">
            <span className="text-muted fw-medium">Thời gian ra bãi:</span>
            <span className="fw-semibold text-dark">{ticket.checkOutTime}</span>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-top-0 pt-0">
        <Button variant="secondary" className="rounded-3 px-4 fw-semibold" onClick={onClose}>
          Đóng
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TicketsTable;
